var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiaLinksTitleBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 334.98 123.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "37.58 9.9 37.58 0 11.68 0 0 0 0 9.9 0 23.87 0 33.77 0 57.64 11.68 57.64 11.68 33.77 34.79 33.77 34.79 23.87 11.68 23.87 11.68 9.9 37.58 9.9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 22.98,
    width: 57.64,
    height: 11.68,
    transform: "translate(79.86 -22.22) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.68 112.88 11.68 65.13 0 65.13 0 122.78 2.71 122.78 11.68 122.78 37.5 122.78 37.5 112.88 11.68 112.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.22,
    y: 88.12,
    width: 57.64,
    height: 11.68,
    transform: "translate(145 42.92) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.42 65.13 102.42 103.4 79.48 65.35 79.48 65.13 79.36 65.13 67.8 65.13 67.67 65.13 67.8 65.35 67.8 122.78 79.48 122.78 79.48 84.72 102.42 122.78 114.1 122.78 114.1 65.13 102.42 65.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "158.67 122.78 170.35 122.78 149.4 90.12 169.33 65.13 157.65 65.13 136.09 92.16 136.09 65.13 135.6 65.13 124.41 65.13 123.92 65.13 123.92 122.78 124.41 122.78 135.6 122.78 136.09 122.78 136.09 106.8 142.38 98.92 158.67 122.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.1 57.64 94.8 0 94.72 0 83.12 0 83.04 0 63.74 57.64 75.42 57.64 88.92 17.32 102.42 57.64 114.1 57.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.13 63.48 258.51 63.48 227.53 122.78 219.7 122.78 250.13 63.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "271.2 63.48 279.58 63.48 248.6 122.78 240.77 122.78 271.2 63.48"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.52,90.57l.16-.69c1.09-5.1,2.92-8.91,11.68-13.38,4.56-2.33,6.39-3.47,6.39-5.47,0-1.76-1.15-2.47-2.95-2.47-2.47,0-3.76,1.78-4.38,4.04h-7.78c1.13-5.97,5.35-9.5,12.78-9.5,6.41,0,10.86,2.68,10.86,8.1,0,4.12-2,6.33-8.6,9.51-3.86,1.84-5.82,2.99-6.58,3.98h13.58l-2.14,5.88h-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.98,74.06c0,8.29-4.44,17.08-15.03,17.08-7.39,0-11.01-3.98-11.01-10.93,0-7.35,4.31-17.11,14.97-17.11,7.18,0,11.07,4.14,11.07,10.96Zm-17.51,5.32c-.34,3.9,.48,6.13,2.97,6.13,4.13,0,5.69-5.94,6.04-10.64,.36-3.83-.14-6.2-2.92-6.2-4.19,0-5.85,6.75-6.09,10.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.61,121.8l.16-.69c1.09-5.1,2.92-8.91,11.68-13.38,4.56-2.34,6.39-3.47,6.39-5.47,0-1.76-1.15-2.47-2.95-2.47-2.47,0-3.76,1.78-4.38,4.04h-7.78c1.13-5.97,5.35-9.5,12.78-9.5,6.41,0,10.86,2.68,10.86,8.1,0,4.12-2,6.33-8.6,9.51-3.86,1.84-5.82,2.99-6.58,3.98h13.58l-2.14,5.88h-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.3,121.8l.16-.69c1.09-5.1,2.92-8.91,11.68-13.38,4.56-2.34,6.39-3.47,6.39-5.47,0-1.76-1.15-2.47-2.95-2.47-2.47,0-3.76,1.78-4.38,4.04h-7.78c1.13-5.97,5.35-9.5,12.78-9.5,6.41,0,10.86,2.68,10.86,8.1,0,4.12-2,6.33-8.6,9.51-3.86,1.84-5.82,2.99-6.58,3.98h13.58l-2.14,5.88h-23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.95,105.23c1.32,5.81,5.49,8.36,12.18,8.36s9.53-2.64,9.53-6.87c0-4.71-2.79-6.75-12.68-9.05-15.74-3.7-19.63-9.42-19.63-17.23,0-10.08,7.54-16.93,21.23-16.93,15.36,0,21.48,8.26,22.3,16.72h-12.6c-.6-3.56-2.57-7.43-10.03-7.43-5.08,0-8.14,2.1-8.14,6.2s2.46,5.65,11.8,7.82c16.82,3.96,20.51,10.22,20.51,18.38,0,10.56-7.99,17.81-23.28,17.81s-22.42-7.23-23.8-17.77h12.6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiaLinksTitleBlack);
export default __webpack_public_path__ + "static/media/FiaLinks_title_black.09b2dc9b02e15bffcaf7d0f112a425a5.svg";
export { ForwardRef as ReactComponent };